const formatDate = (date = new Date(), format = "yyyy-MM-dd") => {
  if (typeof date === "string") {
    date = date.replace(/-/g, "/")
    date = new Date(date)
  }
  const y = date.getFullYear()
  const month = date.getMonth() + 1
  const d = date.getDate()
  format = format.replace("yyyy", y)
  format = format.replace("MM", month)
  format = format.replace("dd", d)
  return format
}

export default formatDate
